export const AUTH_LIST = [
    { value: 11, label: '发布监测数据' },
    { value: 12, label: '发布评估结果' },
    { value: 13, label: '生成监测报告' },
    { value: 14, label: '暂停/启动监测' },

    { value: 21, label: '几何' },
    { value: 22, label: '建模' },
    { value: 23, label: '选监测对象' },
    // { value: 24, label: '参数设计' },
    { value: 25, label: '设备系统' },
    // { value: 26, label: '安装与测试' },
    { value: 27, label: '运维' },
]

export const AUTH_ITEM = {
    PUBLISH_MONITOR_DATA: 11,
    PUBLISH_EVALUTATION_RESULT: 12,
    MONITORING_REPORT: 13,
    START_STOP_MONITORING: 14,

    GEOMETRY: 21,
    MODELING: 22,
    SELECT_MONITORING_OBJECT: 23,
    // PARAMETER_DESIGN:24,
    DEVICE_SYSTEM: 25,
    // INSTALLATION_AND_TESTING: 26,
    DEVOPS: 27,
}

export const AUTH_MONITOR_LIST = [
    { value: 11, label: '发布监测数据' },
    { value: 12, label: '发布评估结果' },
    { value: 13, label: '生成监测报告' },
    { value: 14, label: '暂停/启动监测' },
]

export const AUTH_MENU_LIST = [
    { value: 21, label: '几何' },
    { value: 22, label: '建模' },
    { value: 23, label: '选监测对象' },
    // { value: 24, label: '参数设计' },
    { value: 25, label: '设备系统' },
    // { value: 26, label: '安装与测试' },
    { value: 27, label: '运维' },
]